import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import PageSeo from "../../common/PageSeo/PageSeo";
import FloatingEnquiry from "../../common/FloatingEnquiry/FloatingEnquiry";
function MainLayout({ children, noTopPadding = false }) {
  return (
    <>
    <PageSeo />
    <Navbar />
  
    <main className="pt-[88px]">
      {children}
    </main>
  
    <FloatingEnquiry />
  
    <Footer />
  </>
  );
}

export default MainLayout;